import { Paper, type PaperProps } from '@mui/material';
import { Alert } from '@side/pantry';

interface AlertPaperProps extends PaperProps {
  alertMessage: string;
}

export function AgentAutocompleteAlertPaper({
  alertMessage,
  children,
  ...props
}: AlertPaperProps) {
  return (
    <Paper
      {...props}
      sx={{ ':has(.MuiAutocomplete-noOptions:empty)': { display: 'none' } }}
    >
      <Alert severity="info" sx={{ mx: 2, mt: 1 }}>
        {alertMessage}
      </Alert>
      {children}
    </Paper>
  );
}

// Pre-configured component for co-agent dropdowns
export function CoAgentAutocompletePaper(props: PaperProps) {
  return (
    <AgentAutocompleteAlertPaper
      {...props}
      alertMessage="State selection is restricted to states covered by the licenses of the primary buyer agent"
    />
  );
}
